module.exports = __webpack_public_path__ + "media/images/forms-icons/number-icon-d9fe244b66c436dc9c163ee043f57ea2.svg";